import { render, staticRenderFns } from "./seniorDismissalPop.vue?vue&type=template&id=0af86d59"
import script from "./seniorDismissalPop.vue?vue&type=script&lang=js"
export * from "./seniorDismissalPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af86d59')) {
      api.createRecord('0af86d59', component.options)
    } else {
      api.reload('0af86d59', component.options)
    }
    module.hot.accept("./seniorDismissalPop.vue?vue&type=template&id=0af86d59", function () {
      api.rerender('0af86d59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/com/seniorDismissalPop.vue"
export default component.exports